import { useState } from 'react';
import api from '../api/axios';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function TrocarSenhaObrigatoria() {
  const { usuario, limparTrocaSenhaObrigatoria } = useAuth();
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (senha.length < 6) return toast.error('A nova senha deve ter ao menos 6 caracteres');
    if (senha !== confirmar) return toast.error('As senhas não coincidem');
    setLoading(true);
    try {
      await api.put('/auth/senha', { novaSenha: senha });
      limparTrocaSenhaObrigatoria();
      toast.success('Senha atualizada!');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao atualizar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-blue-700 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="text-4xl mb-2">🔐</div>
          <h1 className="text-lg font-bold text-gray-800">Defina sua senha</h1>
          <p className="text-gray-500 text-sm mt-1">
            Olá, {usuario?.nome}! Por segurança, defina uma nova senha antes de continuar.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nova Senha</label>
            <div className="relative">
              <input
                type={verSenha ? 'text' : 'password'}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-3 pr-10 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                autoFocus
              />
              <button type="button" tabIndex={-1}
                onClick={() => setVerSenha(v => !v)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg px-1">
                {verSenha ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar Nova Senha</label>
            <input
              type={verSenha ? 'text' : 'password'}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              placeholder="Repita a nova senha"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold text-base hover:bg-blue-700 transition-colors disabled:opacity-50 mt-2"
          >
            {loading ? 'Salvando...' : 'Salvar e Continuar'}
          </button>
        </form>
      </div>
    </div>
  );
}
